import React from 'react';
import { MetadataSingleSelectComponentProps } from '../../MetadataSelectProps';
import { GeneralLedgerCounterpartSelectSettings } from './GeneralLedgerCounterpartSelectSettings';
import { useInternationalisation } from '../../../../internationalisation/hooks/useInternationalisation';
import {
  cannotMapSettingsToValidQueryParameters,
  MetadataSingleSelect,
} from '../../MetadataSingleSelect';
import {
  GetGeneralLedgerCounterpartDropdownOptionsResponse,
  mapGeneralLedgerCounterpartDropdownOptionsResponseToSelectOptions,
} from './GetGeneralLedgerCounterpartDropdownOptionsResponse';

export type GeneralLedgerCounterpartSelectOptionValue = number | null;

type Props = MetadataSingleSelectComponentProps<
  GeneralLedgerCounterpartSelectOptionValue,
  GeneralLedgerCounterpartSelectSettings,
  GetGeneralLedgerCounterpartDropdownOptionsResponse
>;

export const GeneralLedgerCounterpartSelect = (props: Props) => {
  const { settings, ...metadataSingleSelectProps } = props;

  const { translate } = useInternationalisation();

  const placeholder = translate('form.select.defaultPlaceholder');
  const loadingPlaceholder = translate('form.defaultLoadingPlaceholder');

  return (
    <MetadataSingleSelect<
      GeneralLedgerCounterpartSelectOptionValue,
      GeneralLedgerCounterpartSelectSettings,
      GetGeneralLedgerCounterpartDropdownOptionsQuery,
      GetGeneralLedgerCounterpartDropdownOptionsResponse
    >
      endpointUrl="/api/metadata/GetGeneralLedgerCounterpartDropdownOptions"
      settings={settings}
      mapSettingsToQueryParameters={({ companyId, companyReportGroupId, ...otherSettings }) =>
        companyId != null
          ? {
              companyId,
              companyReportGroupId: null,
              ...otherSettings,
            }
          : companyReportGroupId != null
          ? {
              companyId: null,
              companyReportGroupId,
              ...otherSettings,
            }
          : cannotMapSettingsToValidQueryParameters
      }
      mapResponseToOptions={mapGeneralLedgerCounterpartDropdownOptionsResponseToSelectOptions}
      placeholder={placeholder}
      loadingPlaceholder={loadingPlaceholder}
      minWidthInPixels={250}
      {...metadataSingleSelectProps}
    />
  );
};

type GetGeneralLedgerCounterpartDropdownOptionsQuery = (
  | { companyId: number; companyReportGroupId: null }
  | { companyId: null; companyReportGroupId: number }
) & {
  includeAll: boolean;
  includeBlank: boolean;
};
